"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetFilterByTop = exports.useFilterByTop = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const react_1 = require("react");
const slice_1 = require("../../slice");
const selectors_1 = require("../../selectors");
const hooks_1 = require("../../../../store/hooks");
const selectors_2 = require("../../../CommonDataProvider/selectors");
const utils_1 = require("../../../CommonDataProvider/utils");
const useFilterByTop = (listKey, topTagNames) => {
    const dispatch = (0, hooks_1.useAppDispatch)();
    const entityTags = (0, hooks_1.useAppSelector)(selectors_2.selectEntityTags);
    const isTop = (0, exports.useGetFilterByTop)({ listKey });
    const topTags = (0, react_1.useMemo)(() => (0, utils_1.getTopTagIds)(entityTags, topTagNames), [entityTags, topTagNames]);
    const onToggleTop = (0, react_1.useCallback)(() => {
        if (topTags.length > 0) {
            dispatch(slice_1.eventsProviderActions.updateFilters({
                listKey,
                filters: {
                    tagIds: isTop ? [] : topTags,
                    tagFilterOperation: isTop ? undefined : betweb_openapi_axios_1.TagFilterOperation.Loose,
                },
            }));
        }
    }, [topTags, dispatch, listKey, isTop]);
    return { isTop, onToggleTop };
};
exports.useFilterByTop = useFilterByTop;
const useGetFilterByTop = ({ listKey, }) => {
    const filters = (0, hooks_1.useAppSelector)((state) => (0, selectors_1.getEventListFilters)(state, listKey));
    return filters.tagIds ? filters.tagIds.length > 0 : false;
};
exports.useGetFilterByTop = useGetFilterByTop;
//# sourceMappingURL=useFilterByTop.js.map